module.exports = __webpack_public_path__ + "img/SeafarersHeroesOfPandemic_7-9-2021.ca176ec1.jpg";